<footer
  class="footer my-auto flex-col lg:flex"
  [class.hidden]="shouldHideFooter$ | async">
  <div
    class="footer-content-container typo-small-text-desktop mx-0 flex flex-col items-center justify-between py-6 text-center lg:w-full lg:flex-row">
    <div class="copyright-section flex flex-col justify-start">
      <span [attr.aria-hidden]="true">
        {{
          'wl.star.footer.copyright'
            | translate: { currentYear: copyrightPresentYear }
        }}
      </span>
      <span> {{ 'wl.star.footer.star_contact' | translate }} </span>
    </div>

    <ul
      class="links-container my-0 flex list-none flex-row flex-wrap items-center justify-center px-0 md:justify-start lg:w-96 lg:justify-end">
      <li
        class="link-wrapper mr-2 mt-6 border-0 border-r border-solid border-[#f1f1f1] pr-2 leading-3 lg:mr-4 lg:mt-0 lg:pr-4">
        <a
          class="link-item focus-link"
          rdOpenInNewTab
          [href]="starNavLinksService.faqsLink">
          {{ 'wl.star.footer.faqs' | translate }}
        </a>
      </li>

      <li
        class="link-wrapper mr-0 mt-6 border-0 border-solid border-[#f1f1f1] pr-2 leading-3 md:mr-2 md:border-r lg:mr-4 lg:mt-0 lg:pr-4">
        <a class="link-item focus-link" rdOpenInNewTab [href]="tenantTncsUrl">
          {{ 'wl.star.footer.terms_of_use' | translate }}
        </a>
      </li>

      <li
        class="link-wrapper mr-2 mt-6 border-0 border-r border-solid border-[#f1f1f1] pr-2 leading-3 lg:mr-0 lg:mt-0 lg:border-none lg:pr-0">
        <a
          class="link-item focus-link"
          rdOpenInNewTab
          [href]="tenantPrivacyPolicyUrl">
          {{ 'wl.star.footer.privacy_policy' | translate }}
        </a>
      </li>

      <li
        class="link-wrapper mr-0 mt-6 border-0 border-solid border-[#f1f1f1] pr-2 leading-3 md:mr-2 md:border-r lg:mr-4 lg:mt-0 lg:pr-4">
        <a
          class="link-item focus-link"
          rdOpenInNewTab
          [href]="tenantPrivacyStatementUrl">
          {{ 'wl.star.footer.privacy_statement' | translate }}
        </a>
      </li>

      <li
        class="link-wrapper mr-2 mt-6 border-0 border-r border-solid border-[#f1f1f1] pr-2 leading-3 lg:mr-4 lg:mt-0 lg:pr-4">
        <a
          class="link-item contact-us-link focus-link"
          rdOpenInNewTab
          [href]="starNavLinksService.contactUsFormLink">
          {{ 'wl.star.footer.contact_us' | translate }}
        </a>
      </li>

      <li class="link-wrapper mt-6 leading-3 lg:mt-0">
        <a
          class="link-item focus-link"
          rdOpenInNewTab
          [href]="starNavLinksService.cookiePolicylink">
          {{ 'wl.star.footer.cookie' | translate }}
        </a>
      </li>
    </ul>
  </div>

  <aside class="footer-terms-container typo-caption-mobile bg-[#333] px-6">
    <div class="screen-max-size py-4">
      <p>
        <sup>1</sup>Earning Star Points: Star Alliance Points are earned in
        accordance with and are subject to HSBC Star Alliance Rewards
        <a
          href="https://www.hsbc.com.au/content/dam/hsbc/au/docs/credit-cards/star-alliance-terms.pdf"
          class="focus-link"
          rdOpenInNewTab>
          Terms and Conditions</a
        >. No points are earned on interest free and other promotions, Balance
        Transfers, business expenses, cash advances, fees and charges, any
        disputed transactions, BPAY® and any government fee or charge.
        Membership, and the earning and redemption of points is subject to the
        <a [href]="tenantTncsUrl" class="focus-link" rdOpenInNewTab>
          terms and conditions
        </a>
        of Star Alliance Rewards. Earn 1 Star Alliance Point per $1 spent up to
        $3,000 per statement period on eligible purchases made in Australia and
        overseas. Every $1 spent thereafter will earn 0.5 Star Alliance Points
        per statement period. The earning of Star Alliance Points is uncapped.
      </p>
      <p>
        <sup>2</sup>Convert Star Alliance Points: Conversion of Star Alliance
        Points to miles/points of participating Frequent Flyer Programs is based
        on a variable conversion rate. Applicable rate for each conversion
        transaction will be displayed at the time of the transaction on the Star
        Rewards online platform. Conversion limits per transaction apply.
        Conversions of Star Alliance Points to miles/points of participating
        Frequent Flyer Programs that you order are irreversible and may not be
        cancelled after they have been ordered. Additional
        <a [href]="tenantTncsUrl" class="focus-link" rdOpenInNewTab>
          Terms and Conditions</a
        >
        apply.
      </p>
      <p>
        <sup>3</sup>Achieve Status: To qualify, you must spend at least AUD
        $30,000 for Star Alliance Silver and AUD $48,000 for Star Alliance Gold
        eligible purchases using your HSBC Star Alliance Credit Card within a
        12-month qualification period starting from the account opening date and
        any subsequent anniversaries thereafter. Refer to the HSBC Terms and
        Conditions for all relevant terms and conditions. Your status will be
        granted through the corresponding status tier in the Frequent Flyer
        Program (FFP) you nominate as your Status Airline. The start date of
        your status may differ depending on the Frequent Flyer Program you
        select and may not be until the next anniversary of the opening of your
        card account - more information is available
        <a
          href="http://www.staralliance.com/en/web/rewards/au/faqs/?subCategory=87"
          class="focus-link"
          rdOpenInNewTab>
          here</a
        >. Generally, your status will be granted for a period of at least 12
        months, or less if, during that period, you qualify, by any means, for a
        higher status with the participating Frequent Flyer Program you chose to
        receive your status with. Exceptions apply, please refer to the
        <a [href]="tenantTncsUrl" class="focus-link" rdOpenInNewTab>
          Star Alliance Rewards Terms and Conditions</a
        >. You may not be able to receive Star Alliance Silver or Star Alliance
        Gold Status with a participating Frequent Flyer Program if you already
        hold, by any means, an equivalent or higher status with that Program –
        please refer to the applicable rules
        <a
          href="http://www.staralliance.com/en/web/rewards/au/faqs/?subCategory=87"
          class="focus-link"
          rdOpenInNewTab>
          here</a
        >. You may only request status with one participating Frequent Flyer
        Program each time you qualify and may not switch Programs during the
        duration of that status, or any status earned in the same qualification
        year. Any status will only be granted if your account is active and not
        in arrears and will be withdrawn immediately if you close your HSBC Star
        Alliance Credit Card account. Additional Terms and Conditions apply
        under the Star Alliance Rewards Program. Benefits of Star Alliance
        Silver and Star Alliance Gold status available
        <a
          href="https://www.staralliance.com/en/recognition"
          class="focus-link"
          rdOpenInNewTab>
          here
        </a>
        and are subject to change.
      </p>
      <p>
        <sup>4</sup>Travel Related Redemptions/ References to Travel:
        Redemptions for travel subject to the terms, conditions, inventory and
        availability of the Member Airline Frequent Flyer Program through which
        redemption is sought. Travel subject to any applicable immigration and
        health requirements of departure, destination and any intermediary
        points.
      </p>
      <p>
        <sup>5</sup>Credit provided by HSBC Bank Australia Limited ABN 48 006
        434 162 Australian Credit Licence 232595. Offers available to new,
        approved HSBC credit cardholders. Fees, charges, terms, conditions and
        HSBC's lending criteria applies to all credit cards issued by HSBC.
        Visit
        <a href="https://www.hsbc.com.au/" class="focus-link" rdOpenInNewTab>
          www.hsbc.com.au</a
        >
        or call
        <a href="tel:1300308880" class="focus-link" rdOpenInNewTab
          >1300 308 880</a
        >. Interest rates are valid at the time of publication and are subject
        to change.
      </p>
    </div>
  </aside>
</footer>
